import React from 'react';
import { Button } from 'antd';
import get from 'lodash/get';
import { orderBy } from 'lodash';
import PropTypes from 'prop-types';

import style from '../../index.scss';
import { convertISOToDateTimeFormat } from '../../../../../util/timezone';

export const CreationDetailsComponent = ({ GS, data }) => {
  if (GS && GS.widgetConfig && data) {
    const sortedSettings = orderBy(
      GS.widgetConfig,
      ['columnIndex'],
      ['asc']
    ).filter((column) => column.columnVisibility);
    return sortedSettings.map((setting, key) => {
      return (
        <div key={setting?.columnIndex}>
          {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
            .filter((column) => column.visibility)
            .map((column, idx) => {
              return (
                <div key={idx} className={style.contentBody}>
                  <p className={style.contentLabel}>
                    <label>{column.itemLabel}:</label>
                  </p>
                  <p className={style.contentValue}>
                    {data[column.itemName]
                      ? column.itemName == 'createdAt'
                        ? convertISOToDateTimeFormat(data[column.itemName])
                        : data[column.itemName]
                      : '--'}
                  </p>
                </div>
              );
            })}
        </div>
      );
    });
  }
  return <p>N/A</p>;
};

export const ApproveRejectCtaComponent = ({
  onRejectIconClickedHandler,
  apiActions,
  match,
  location
}) => (
  <React.Fragment>
    {location?.state?.state == 'Created' && (
      <React.Fragment>
        <Button
          id={'newChallenger_rejectBtn'}
          className={style.rejectBtn}
          onClick={() =>
            onRejectIconClickedHandler({
              id: get(match, 'params.id', '')
            })
          }>
          Reject
        </Button>
        <Button
          id={'newChallenger_ApproveBtn'}
          className={style.approveBtn}
          onClick={() =>
            apiActions?.putAMLSCommonApproveAndRejectTicket({
              status: 'Approved',
              ticketId: get(match, 'params.id', ''),
              championName: location?.state?.itemName,
              runInstanceId: location?.state?.challengerId
            })
          }>
          Approve
        </Button>
      </React.Fragment>
    )}
  </React.Fragment>
);

export const NewChallengerCta = (props) => (
  <div className={style.ctaWrapper}>
    <div className={style.contentWrapper}>
      <CreationDetailsComponent {...props} />
    </div>
    <div className={style.btnWrapper}>
      <ApproveRejectCtaComponent {...props} />
    </div>
  </div>
);

CreationDetailsComponent.propTypes = {
  GS: PropTypes.object,
  data: PropTypes.object
};

ApproveRejectCtaComponent.propTypes = {
  apiActions: PropTypes.shape({
    putAMLSCommonApproveAndRejectTicket: PropTypes.func
  }),
  onRejectIconClickedHandler: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object
};

export default NewChallengerCta;
